import { render, staticRenderFns } from "./Scopes.vue?vue&type=template&id=b81364f2&scoped=true&"
import script from "./Scopes.vue?vue&type=script&lang=js&"
export * from "./Scopes.vue?vue&type=script&lang=js&"
import style0 from "./Scopes.vue?vue&type=style&index=0&id=b81364f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81364f2",
  null
  
)

export default component.exports